import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import mapboxgl from 'mapbox-gl';
import MapboxLanguage from '@mapbox/mapbox-gl-language';
import '../../vendor/mapbox-gl-styles';

export default class MapboxMap extends Component {

  DEFAULT_ZOOM = 5;

  _id = null;

  _options = null;

  _map = null;

  markers = {};

  constructor(App, namespace, id, options) {
    super(...arguments);

    this.id = id;
    this.options = options;
    this.configure();
    this.initialize();
  }

  configure() {
    mapboxgl.accessToken = window.keys.mapbox || '';
    return super.configure();
  }

  initialize() {
    this.start();
    return super.initialize();
  }

  set id(value) {
    this._id = value;
  }

  get id() {
    return this._id;
  }

  set options(value) {
    this._options = value;
  }

  get options() {
    return this._options;
  }

  set map(value) {
    this._map = value;
  }

  get map() {
    return this._map;
  }

  start() {

    // Create map instance
    this.map = new mapboxgl.Map(this.getConfig());
    this.map.on('load', (event) => {
      return this.onLoad(event);
    });

    this.setControls();
  }

  getConfig() {

    let config = {
      container: this.id,
      style: 'mapbox://styles/mapbox/outdoors-v11',
      center: [0, 0],
      zoom: this.DEFAULT_ZOOM,
      pitchWithRotate: false,
      dragRotate: false,
      // hash: true,
      attributionControl: false,
      logoPosition: 'bottom-right'
    };

    // Merges config
    config = $.extend(config, (this.options.config || {}));

    return config;
  }

  /**
   * Sets map's controls
   */
  setControls() {

    // Auto language plugin
    this.map.addControl(new MapboxLanguage({
      // getLanguageField: Lang.getLocale,
      defaultLanguage: this.App.Language.getLocale()
    }));

    // Scale plugin
    let scale = new mapboxgl.ScaleControl({
      maxWidth: 100,
      unit: 'metric'
    });
    this.map.addControl(scale);

    // Navigation: zoom
    let nav = new mapboxgl.NavigationControl({
      showCompass: false
    });
    this.map.addControl(nav, 'top-left');

    // Style switcher
    this.map.addControl(new StylesControl([{
      name: 'Схема',
      url: 'mapbox://styles/mapbox/outdoors-v11',
      isDefault: true
    }, {
      name: 'Спутник',
      url: 'mapbox://styles/mapbox/satellite-streets-v11'
    }]), 'top-right');

  }

  /**
   * Runs when map is loaded
   */
  onLoad() {
    this.logger('Map is loaded and ready')
  }

  /**
   * Sets map center
   *
   * @param coordinates
   * @param zoom
   */
  setCenter(coordinates, zoom) {
    this.map.setCenter(coordinates).setZoom(zoom || this.map.getZoom());
  }

  /**
   * Moves map to specified point
   *
   * @param coordinates
   * @param options
   */
  moveTo(coordinates, options) {
    options = $.extend({
      center: coordinates,
      speed: 2.5,
      maxDuration: 3000
    }, options);
    this.map.flyTo(options);
  }

  /**
   * Fits map's bounds
   *
   * @param bbox
   * @param options
   */
  fitBounds(bbox, options) {

    if (!bbox) {
      // TODO: auto
    }

    this.map.fitBounds(bbox, options || {padding: 50});
  }

  /**
   * Fits map's bounds
   *
   */
  getBounds() {
    return this.map.getBounds();
  }

  /**
   * Adds marker on the map
   *
   * @param coordinates
   * @param options
   * @param name
   * @param properties
   * @returns {Marker}
   */
  addMarker(coordinates, options, name, properties) {
    let marker = new mapboxgl.Marker(options || null).setLngLat(coordinates);
    marker.properties = properties || {};
    marker.addTo(this.map);
    if (typeof name === 'string') this.markers[name] = marker;
    return marker;
  }

  /**
   * Sets marker's popup
   *
   * @param marker Marker
   * @param contents
   * @param events array
   * @returns {Marker}
   */
  setMarkerPopup(marker, contents, events) {
    let markerElement = marker.getElement();

    marker.setPopup(
      new mapboxgl.Popup({
        offset: 15
      }).setHTML(contents)
    );

    /*
    if (events.indexOf('hover') >= 0) {

      markerElement.addEventListener('mouseenter', function(){
        if (!marker.getPopup().isOpen()) marker.togglePopup();
      });

      markerElement.addEventListener('mouseleave', function(){
        if (marker.getPopup().isOpen()) marker.togglePopup();
      });

    }
    */

    return marker;
  }

}